







































import Vue from "vue"
import { PickupDiff } from "@/model/entity/pickup-diff/pickup-diff"
import { pickupDiffService } from "@/model/service/pickupdiff/pickupdiff-service"
import NewCarorderForm from "@/components/new-carorder/NewCarorderForm.vue"
import * as _ from "lodash"

export default Vue.extend({
  components: { NewCarorderForm },
  data() {
    return {
      carorder: new PickupDiff(),
      carorderService: pickupDiffService,
      carorderFormsValid: false,
      displayMsg: false
    }
  },
  methods: {
    addAddress() {
      this.carorder.name = this.$store.getters.loggedUser.office.company.name
      this.carorder.postalCode = this.$store.getters.loggedUser.office.officeZip
      this.carorder.city = this.$store.getters.loggedUser.office.officeCity
      this.carorder.street = this.$store.getters.loggedUser.office.officeStreet
      this.carorder.houseNumber = this.$store.getters.loggedUser.office.officeHouseNumber
      this.carorder.mobile = this.$store.getters.loggedUser.office.officeTel
      this.carorder.email = this.$store.getters.loggedUser.office.officeEmail
      this.carorder.office = this.$store.getters.loggedUser.office
      this.carorder.contactName = this.$store.getters.loggedUser.office.officeContactPerson
      this.carorder.phone = this.$store.getters.loggedUser.office.officeTel
    },
    reset() {
      const vm = this
      vm.carorder = new PickupDiff()
      vm.$nextTick(() => {
        const form = vm.$refs.form as any
        form.reset()
        vm.$forceUpdate()
      })
    },
    save() {
      const vm = this
      vm.startLoad()
      const postalCode = vm.carorder.postalCode
      const undeliverableZipcodes = [21485, 23210, 23273, 51550]
      vm.carorderService
        .checkZipCodeCountry(vm.carorder)
        .then(response => {
          if (!response.data) {
            if (_.includes(undeliverableZipcodes, Number(postalCode))) {
              vm.$confirm(vm.$t(`undeliverable_zipcode.${postalCode}.warning`).toString(), {
                confirmButtonText: "OK",
                type: "warning",
                center: true,
                showCancelButton: false
              })
            } else {
              vm.$confirm(vm.$t("undeliverable_zipcode.warning").toString(), {
                confirmButtonText: "OK",
                type: "warning",
                center: true,
                showCancelButton: false
              })
            }
          } else {
            this.displayMsg = true
          }
        })
        .catch(error => {
          vm.$error(error.response.data.message)
          vm.endLoad()
        })
      vm.carorderService
        .create(vm.carorder)
        .then(response => {
          vm.endLoad()
          if (response.data.code === 0) {
            if (this.displayMsg) {
              vm.$message({
                message: vm.$t("new_carorder.save_success").toString(),
                type: "success"
              })
            }
            vm.reset()
            vm.scrollToTop()
          } else {
            vm.$error(vm.$t(response.data.message))
          }
        })
        .catch(error => {
          vm.$error(error.data.message || error.response.data.message)
          vm.endLoad()
        })
    },
    scrollToTop() {
      (this.$refs.newOrderPanelContainer as Vue).$el.scrollTop = 0
    }
  },
  computed: {
    validated(): boolean {
      const carorder = this.carorder
      return this.carorderFormsValid && !isNaN(carorder.pickupTimeFrom) && !isNaN(carorder.pickupTimeTo)
    }
  }
})
